import React, { useState } from 'react'
import { FormSelectField } from '@/components/Form/FormField'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { UpdateClientStatus } from 'api/Clients/Types/UpdateClientStatus'
import { getEnumEntries } from 'utils/getEnumEntries'

import { ClientNavigation, ClientTab } from '../../Navigation/ClientNavigation'
import { ClientDetailsBackOfficeNotes } from './ClientDetailsBackOfficeNotes'
import { ClientDetailsPaymentsNotes } from './ClientDetailsPaymentsNotes'
import { getNoteViewType, isNoteTypeBackOffice, isNoteTypePayments, NotesViewType } from './types'

interface Props {
  data: ClientDetailedDto

  forceRefresh(): void
  updateClientStatus(values: UpdateClientStatus): void
}

const ClientDetailsNotes: React.FC<Props> = ({ data, updateClientStatus }) => {
  const [noteType, setNoteType] = useState<NotesViewType>(getNoteViewType())

  const handleNotesViewType = (value: string | number) =>
    setNoteType(getNoteViewType(value.toString()))

  return (
    <>
      <ClientNavigation
        isEdit={false}
        data={data}
        tab={ClientTab.NOTES}
        updateClientStatus={updateClientStatus}
      />
      <FormSelectField
        className='max-w-xs pb-2'
        onChange={handleNotesViewType}
        value={noteType}
        options={getEnumEntries(NotesViewType).map(([key, val]) => ({ name: key, id: val }))}
        label='Type'
      />

      <ClientDetailsNotesFactory data={data} viewType={noteType} />
    </>
  )
}

interface ClientDetailsNotesFactoryProps {
  data: ClientDetailedDto
  viewType: NotesViewType
}

const ClientDetailsNotesFactory = (props: ClientDetailsNotesFactoryProps) => {
  if (isNoteTypePayments(props.viewType)) {
    return <ClientDetailsPaymentsNotes {...props} />
  }
  if (isNoteTypeBackOffice(props.viewType)) {
    return <ClientDetailsBackOfficeNotes {...props} />
  }
  return null
}

export default ClientDetailsNotes
